import { Container, Grid, Link, Box } from '@mui/material';
import React from 'react';
import ImproveScss from './Improve.module.scss';

function Improve(props) {
    return (
        <section id={ImproveScss.improve} >
            <div className={ImproveScss.improve}>
                <Container maxWidth='lg' >
                    <Grid container >
                        <Grid item xs={12} >
                            <Box className={ImproveScss.processItem}>
                                <span>{props.head}</span>
                                <p>{props.content}</p>
                                <Link href='#'>contact us</Link>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </div>
        </section >
    )
}

export default Improve;
